var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiCirculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 693,
    viewBox: "0 0 152 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -323.5,
    cy: 217.5,
    r: 475.5,
    fill: "#F2F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiCirculo);
export default __webpack_public_path__ + "static/media/semiCirculo.9ea7e9f698422324f9a2577d73a4aa43.svg";
export { ForwardRef as ReactComponent };